import { format } from 'date-fns';

import HistoryChangeView from './HistoryChangeView';
import HistoryEntryIcon from './HistoryEntryIcon';
import type { HistoryEntryView } from './private-event-history-rows';

/** Viewer-local time, with the year once it is not this year's. */
function formatWhen(iso: string): string {
  const when = new Date(iso);
  const sameYear = when.getFullYear() === new Date().getFullYear();
  return format(when, sameYear ? 'MMM d, h:mm a' : 'MMM d, yyyy, h:mm a');
}

/** One saved change: who, when (viewer local time) and every field it touched. */
export default function HistoryEntryRow({ entry }: { entry: HistoryEntryView }) {
  const hasHeadcount = entry.changes.some((c) => c.kind === 'headcount');
  return (
    <li
      style={{
        display: 'flex',
        gap: 10,
        padding: '9px 16px',
        borderTop: '1px solid var(--nb-border)',
        alignItems: 'flex-start',
        background: hasHeadcount ? 'var(--nb-surface)' : 'transparent',
      }}
    >
      <HistoryEntryIcon entry={entry} />
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 3 }}>
        {entry.showTitle && (
          <strong style={{ fontSize: 12, color: 'var(--nb-ink)', fontWeight: 700 }}>
            {entry.title}
          </strong>
        )}
        {entry.changes.map((change) => (
          <HistoryChangeView key={change.key} change={change} />
        ))}
        <div style={{ fontSize: 10.5, color: 'var(--nb-subtle)', marginTop: 2 }}>
          {entry.actorName} · <time dateTime={entry.changedAt}>{formatWhen(entry.changedAt)}</time>
        </div>
      </div>
    </li>
  );
}
